import { createSlice } from '@reduxjs/toolkit';

const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        isProfileOpen: false,
        familyName: '',
        givenName: '',
        email: '',
        avatar: null, // URL изображения
    },
    reducers: {
        toggleUserProfile(state) {
            state.isProfileOpen = !state.isProfileOpen;
        },
        setUserData(state, action) {
            state.familyName = action.payload.familyName;
            state.givenName = action.payload.givenName;
            state.email = action.payload.email;
        },
        setUserAvatar(state, action) {
            state.avatar = action.payload;
        },
    },
});

export const { toggleUserProfile, setUserData, setUserAvatar } = profileSlice.actions;
export default profileSlice.reducer;
